import React from "react";
import { EmployeeClassificationsTypesContainer } from "../../containers";

const EmployeeClassifications = (props) => {
  return <EmployeeClassificationsTypesContainer {...props} />;
};

export default EmployeeClassifications;
